<template>
 <!-- 雇主险管理 -->
  <div>
    <div v-show="Gzxcx">
      <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">雇主险出险</div>
    <!-- 主体 -->
    <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
      <!-- 查询框 -->
      <div style="margin-left:2%">
        <div style="height:40px"></div>
        <div style="display:inline-block">
            <span>组织架构</span>
            <el-cascader v-model="condition.organize_ids" clearable
                style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
        </div>

        <!-- <div style="display:inline-block;margin-left:10px">
            <span>城市 </span>
            <el-select v-model="condition.city_id" style="margin-left:10px;width:150px"
                :placeholder="postPlaceholder" clearable>
                <el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city" :value="item.city">
                </el-option>
            </el-select>
        </div> -->

        <div style="display:inline-block;margin-left:10px">
            <span>岗位 </span>
            <el-select v-model="condition.post_id" style="margin-left:10px;width:150px" placeholder="请选择" clearable>
              <el-option v-for="item in postList" :key="item.id" :label="item.post_name" :value="item.id">
              </el-option>
            </el-select>
        </div>

        <div style="display:inline-block;margin-left:10px">
            <span>姓名 </span>
          <el-input v-model="condition.staff_name" style="margin-left:10px;width:150px" placeholder="请输入姓名"></el-input>
        </div>

        <div style="display:inline-block;margin-left:10px">
            <span>保单号 </span>
          <el-input v-model="condition.policy_no" style="margin-left:10px;width:150px" placeholder="请输入保单号"></el-input>
        </div>

        <div style="display:inline-block">
            <span>出险时间</span>
            <el-date-picker v-model="condition.danger_dete" value-format = "yyyy-MM-dd"
            style="margin-left:10px;width:160px" type="date" placeholder="选择日期"></el-date-picker>
        </div>

        <!-- <div style="display:inline-block;margin-top:20px">
            <span>审批状态 </span>
            <el-select v-model="condition.approval_status" style="margin-left:10px;width:150px"
                placeholder="请选择" clearable>
                <el-option v-for="item in spztList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </div> -->

        <div style="display:inline-block;margin-left:10px">
            <span>出险状态 </span>
            <el-select v-model="condition.state" style="margin-left:10px;width:150px"
                placeholder="请选择" clearable>
                <el-option v-for="item in cxztList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </div>

        <!-- 按钮 -->
        <div style="display:inline-block;margin-left:50px">
          <el-button type="goon" @click="Find">查询</el-button>
          <el-button type="goon">导入</el-button>
          
          <div style="display:inline-block; margin-left:10px ">
						<download-excel class="export-excel-wrapper" :fields="download_excel" title="雇主险出险人员"
									name="雇主险出险人员.xls" :fetch="ExportForm"
									style="top:100px">
							<el-button type="goon" >导出</el-button>
						</download-excel>
          </div>
          <el-button type="goon" @click="Del()" style="margin-left:10px">删除</el-button>
          <el-button type="addbtn" @click="add()">新增</el-button>
        </div>
      </div>

      <!-- 表格 -->
      <div style="margin:1% 3% 0 3%">
        <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                        style="width: 100%;" height="540" @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="45">
          </el-table-column>
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
          </el-table-column>
          <el-table-column align="center" label="组织架构" width="300">
			  <template slot-scope="scope">
			  	{{$globals.group_name + "/" + scope.row.range}}
			  </template>
		  </el-table-column>
          <!-- <el-table-column prop="city_id" align="center"  label="城市"></el-table-column> -->
          <el-table-column prop="staff_name" align="center" label="姓名" width="120"></el-table-column>
          <el-table-column prop="staff_gender" align="center" label="性别" width="60"></el-table-column>
          <el-table-column prop="staff_card" align="center" label="身份证号" width="200"></el-table-column>
          <el-table-column prop="staff_telephone" align="center" label="手机号" width="120"></el-table-column>
          <el-table-column prop="post_name" align="center" label="岗位" width="120"></el-table-column>
          <el-table-column prop="danger_dete" align="center" label="出险时间" width="100"></el-table-column>
          <el-table-column prop="policy_no" align="center" label="保单号" width="200"></el-table-column>
          <el-table-column prop="close_date" align="center" label="结案日期" width="100"></el-table-column>
          <!-- <el-table-column prop="state" align="center" label="状态"  width=100>
            <template slot-scope="scope">
                <img src="../../../assets/待审批.png" v-show="scope.row.approval_status == '0'" />
                <img src="../../../assets/已同意.png" v-show="scope.row.approval_status == '1'" />
                <img src="../../../assets/stateImg/状态_已驳回.png"
                                    v-show="scope.row.approval_status == '2'" />
            </template>
          </el-table-column> -->
          <el-table-column prop="states" align="center" label="出险状态" width=100>
            <template slot-scope="scope">

              {{ scope.row.settlement_status == '0' ? "未理赔":( scope.row.settlement_status == '1' ? "已理赔": "已撤案" ) }}
                <!-- <img src="../../../assets/未出险.png" v-show="scope.row.settlement_status == '0'" />
                <img src="../../../assets/已出险.png" v-show="scope.row.state == '1'" /> -->
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="180">
            <template slot-scope="scope">
              <img src="../../../assets/详情.png" @click="xiangqing(scope.row)">
              <img src="../../../assets/编辑.png" @click="Edit(scope.row)">
              <img src="../../../assets/删除.png" @click="Del(scope.row.id)"/>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-row style="margin-top: 10px; text-align: center;">
            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                layout=" prev, pager, next, jumper" :total="total">
            </el-pagination>
        </el-row>
      </div>
      
    </div>
    </div>
    <add ref="adds" v-show="showadd" :staffList="staffList"></add>
    <edit ref="edits" v-show="showedit"></edit>
  </div>
</template>

<script>
import axios from 'axios';
import add from './Gzxcx_add.vue';
import edit from './Gzxcx_edit.vue';
export default {
  components: {
    add:add,
    edit:edit,
  },
  data() {
	  var organizeFind = async (e, spare8) => {
	  	var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
	  		identification: "1",
	  		organize_id: e,
	  		spare8: spare8,
	  	});
	  	return organizeList.data;
	  };
    return {
      //列表相关
      page_num: 1,
      page_size: 10,
      total: 0,
      //分公司下拉
      fgsList: [],
      //板块下拉
      bkList: [],
      xmList:[],
      //岗位下拉
      postList: [],
      //删除ids
      ids: [],
      //审批状态下拉
      spztList: [{
          value: '0',
          label: '待审批'
      }, {
          value: '1',
          label: '已同意'
      }, {
          value: '2',
          label: '已驳回'
      }],
      // 出险状态下拉
      cxztList:[{
          value: '0',
          label: '未出险'
      }, {
          value: '1',
          label: '已出险'
      }, {
					value: '2',
					label: '已撤案'
			}],
      tableData:[],
      ruleForm:{
        id:'',
        range:'',
        company_id:'',
        modular_name:'',
        modular_id:'',
        city_id:'',
        project_name:'',
        staff_name:'',
        staff_gender:'',
        staff_card:'',
        staff_telephone:'',
        post_name:'',
        danger_dete:'',
        policy_no:'',
        close_date:'',
        approval_status:'',
        state:'',
        company_id:'',
        staff_id:'',
        staff_card:'',
        staff_telephone:'',
        city_name:'',
        settlement_status:'',
        staff_age:'',
        project_name:'',
        post_name:'',
        danger_after:'',
        report_no:'',
        settlement_amount:'',
        indemnity_amount:'',
        remarks:'',
        bill_url:'',
        accident_photo:[],
      },
      //条件
      condition: {
          organize_ids: [],
          city_id: '',
          post_id:'',
          staff_name: '',
          policy_no: '',
          danger_dete: '',
          approval_status: '',
          state: '',
      },
      download_excel:{
        "员工姓名":"staff_name",
        "职位名称":"post_name",
        "员工身份证号": {
						field: "staff_card",
						callback: value => {
							return "&nbsp;" + value;
						}
					},
        "员工性别":"staff_gender",
        "组织架构":"range",
        "出险时间":"danger_dete",
        "报案号":"report_no",
        "保单号":"policy_no",
        "理赔情况":"settlement_status",
        "收保险公司理赔款数":"settlement_amount",
        "付员工理赔款数":"indemnity_amount",
        "结案日期":"close_date",
        "提交人":"created_by_name" ,
        "最后修改人":"modified_by_name" ,
        "情况备注":"remarks",
      },
      // 权限
      Gzxcx:true,
	
	  //组织架构数据
	  organizeList: [],
	  
	  //级联下拉配置
	  props: {
		  lazy: true,
		  async lazyLoad(node, resolve) {
		  	if (node.level === 0) {
		  		return resolve(await organizeFind('', 'group'));
		  	} else {
		  		resolve(await organizeFind(node.data.id, ''));
		  	}
		  },
	      value: "id",
	      label: "organize_name",
	      children: "organizeList",
	      checkStrictly: true,
	      multiple: true,
	  },
	  
	  //员工数据
	  staffList:[],
      
    }
  },
  methods: {
    // 全选
    handleSelectionChange(e) {
      this.ids = [];
      e.forEach(item => {
          this.ids.push(item.id);
      });
    },
    //分页
    handleCurrentChange(val) {
        this.page_num = val;
        this.Find();
    },
    Return(){
        this.showadd = false;
        this.showedit = false;
        this.Gzxcx = true;
        this.Find();
        this.trash();
    },
    // 新增
    add(){
      this.Gzxcx = false;
      this.showadd = true;
      this.$refs.adds.add;
      this.Find();
      this.trash();
    },
    //查询
    async Find() {
		var temporary = [];
		this.condition.organize_ids.forEach(item => {
		    temporary.push(item[item.length - 1]);
		})
		var organize_ids = "";
		temporary.forEach(item => {
		    organize_ids += item + ",";
		})
		
        var url = 'Danger/selectAll';
        var record = {
            page_num: this.page_num,
            page_size: this.page_size,
            organize_ids : organize_ids,
            post_id: this.condition.post_id,
            staff_name: this.condition.staff_name,
            policy_no: this.condition.policy_no,
            danger_dete: this.condition.danger_dete,
            approval_status: this.condition.approval_status,
            state: this.condition.state,
        };
        var data = await this.$globals.AxiosPost(url, record);
        if (data === '-2000') {
            this.$message.error('服务器未响应！请稍后重试');
        } else {
            var code = data.code;
            var data = data.data;
            if (code === '200') {
                this.tableData = data.list;
                this.total = data.total;
            } else {
                this.$message.warning('请求失败！请稍后重试');
            }
        }
    },
    //导表
			async ExportForm(){
				var url = 'Danger/GuideTable';
				var record = {};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if(data.length > 0){
							this.$message.success("导出成功！文件下载中！");
							return data;
						}else{
                this.$message.success("没有可以导出的数据！");
                return null;
            }
					}
				}
			},
    // 操作修改 
    Edit(e) {
        this.Gzxcx = false;
        this.showadd = true;
        this.ruleForm.id = e.id;
        this.ruleForm.staff_name = e.staff_name;
        this.ruleForm.company_id = e.company_id;
        this.ruleForm.staff_id = e.staff_id;
        this.ruleForm.staff_card = e.staff_card;
        this.ruleForm.staff_telephone = e.staff_telephone;
        this.ruleForm.city_id = e.city_id;
        this.ruleForm.staff_gender = e.staff_gender;
        this.ruleForm.range = this.$globals.group_name + "/" + e.range;
        this.ruleForm.post_name = e.post_name;
        this.ruleForm.danger_dete = e.danger_dete;
        this.ruleForm.danger_after = e.danger_after;
        this.ruleForm.report_no = e.report_no;
        this.ruleForm.policy_no = e.policy_no;
        this.ruleForm.settlement_amount = e.settlement_amount;
        this.ruleForm.indemnity_amount = e.indemnity_amount;
        this.ruleForm.close_date = e.close_date;
        this.ruleForm.remarks = e.remarks;
        this.ruleForm.bill_url = e.bill_url;
        this.ruleForm.accident_photo = e.accident_photo;
        this.ruleForm.settlement_status = e.settlement_status;
        this.ruleForm.staff_age = e.staff_age;
    },
    // 详情
    xiangqing(e){
      this.Gzxcx = false;
      this.showedit = true;
      this.ruleForm.id = e.id;
        this.ruleForm.company_id = e.company_id;
        this.ruleForm.company_name = e.company_name;
        this.ruleForm.staff_id = e.staff_id;
        this.ruleForm.staff_name = e.staff_name;
        this.ruleForm.staff_card = e.staff_card;
        this.ruleForm.staff_telephone = e.staff_telephone;
        this.ruleForm.modular_name = e.modular_name;
        this.ruleForm.city_id = e.city_id;
        this.ruleForm.staff_gender = e.staff_gender;
        this.ruleForm.project_name = e.project_name;
        this.ruleForm.post_name = e.post_name;
        this.ruleForm.danger_dete = e.danger_dete;
        this.ruleForm.danger_after = e.danger_after;
        this.ruleForm.report_no = e.report_no;
        this.ruleForm.policy_no = e.policy_no;
        this.ruleForm.settlement_amount = e.settlement_amount;
        this.ruleForm.indemnity_amount = e.indemnity_amount;
        this.ruleForm.close_date = e.close_date;
        this.ruleForm.remarks = e.remarks;
        this.ruleForm.bill_url = e.bill_url;
        this.ruleForm.accident_photo = e.accident_photo;
        this.ruleForm.settlement_status = e.settlement_status;
        this.ruleForm.staff_age = e.staff_age;
    },
    //删除
    Del(e) {
      var ids;
      if (e === null || e === '' || e === undefined) {
        if (this.ids === null || this.ids.length <= 0) {
          this.$message.warning('请先选择操作数据！');
          return false;
        }
        ids = this.ids;
      } else {
        ids = [e];
      }
      const url = this.$globals.http + '/Danger/del';
      axios
        .post(url, {
          delete_by:this.$globals.user.staff_id,
          ids: ids,
        })
        .then((response) => {
          var code = response.data.code;
          var data = response.data.data;

          if (code === '200') {
            this.$message.success(data);
            this.Find();
          } else {
            this.$message.warning('请求失败！请稍后重试');
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error('服务器未响应！请稍后重试');
        });
    },
      //清除数据
    trash() {
      this.ruleForm.id = '';
      this.ruleForm.company_id = '';
      this.ruleForm.staff_id = '';
      this.ruleForm.staff_card = '';
      this.ruleForm.staff_telephone = '';
      this.ruleForm.modular_name = '';
      this.ruleForm.city_name = '';
      this.ruleForm.staff_gender = '';
      this.ruleForm.project_name = '';
      this.ruleForm.company_name = '';
      this.ruleForm.city_id = ''; 
      this.ruleForm.post_name = '';
      this.ruleForm.danger_dete = '';
      this.ruleForm.danger_after = '';
      this.ruleForm.report_no = '';
      this.ruleForm.policy_no = '';
      this.ruleForm.settlement_amount = '';
      this.ruleForm.indemnity_amount = '';
      this.ruleForm.close_date = '';
      this.ruleForm.remarks = '';
      this.ruleForm.bill_url = '';
      this.ruleForm.accident_photo = [];
      this.ruleForm.settlement_status = '';
      this.ruleForm.staff_age = '';
    },
	//初始化组织架构及下面的人
	async organizeFind() {
	    var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
	        identification: "1",
	    });
	    this.organizeList = this.getTreeData(organizeList.data);
	 
	},
	getTreeData(data) {
	    // 循环遍历json数据
	    for (var i = 0; i < data.length; i++) {
	
	        if (data[i].organizeList.length < 1) {
	            // children若为空数组，则将children设为undefined
	            data[i].organizeList = undefined;
	        } else {
	            // children若不为空数组，则继续 递归调用 本方法
	            this.getTreeData(data[i].organizeList);
	        }
	    }
	    return data;
	}
  },
  async created() {
    this.Find();
	this.organizeFind();
    // 岗位
    var postList = await this.$globals.AxiosPost("post/selectFind", {});
    this.postList = postList.data;
	// 员工
	var staffList = await this.$globals.AxiosPost("staff/selectFind", {});
	this.staffList = staffList.data;
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// Gzxcx.vue?796e4be4